import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submit"];

  declare submitting: boolean;
  declare readonly submitTargets: HTMLElement[];

  initialize() {
    this.submitting = false;
  }

  disconnect() {
    this.enableSubmits();
  }

  disableSubmits() {
    this.submitTargets.forEach((submitTarget) => {
      submitTarget.classList.add("fui-button--loading");
    });
  }

  enableSubmits() {
    this.submitTargets.forEach((submitTarget) => {
      submitTarget.classList.remove("fui-button--loading");
    });
  }

  submitStart(_event: SubmitEvent) {
    const form = this.element;
    if (form) {
      // @ts-ignore
      if ($(form).validate().checkForm()) {
        this.submitting = true;
        this.disableSubmits();
      }
    }
  }

  submitEnd(_event: CustomEvent) {
    const form = this.element;
    if (form) {
      this.submitting = false;
      this.enableSubmits();
    }
  }
}
